import DM from 'DM';
import EventDelegate from '../utils/event-delegate.js';

const CLASSNAMES = {
    CATEGORY: 'js-page-nav__category',
    SUBCATEGORIES: 'js-page-nav__subcategories',
    SUBCATEGORY: 'js-page-subcategory'
};

const SELECTORS = {
    CATEGORY: `.${CLASSNAMES.CATEGORY}`,
    SUBCATEGORIES: `.${CLASSNAMES.SUBCATEGORIES}`,
    SUBCATEGORY: `.${CLASSNAMES.SUBCATEGORY}`
};

class Menu {
    constructor() {
        this.addListeners();
        this.addShowAll();
    }

    addListeners() {
        const delegate = new EventDelegate(document);
        delegate.on('click', SELECTORS.CATEGORY, this.clickHandler.bind(this));
    }

    clickHandler(event) {
        event.originalEvent.preventDefault();
        const gender = event.originalEvent.target.closest(SELECTORS.CATEGORY).dataset.gender;

        this.updateMenu(gender);
    }

    updateMenu(gender) {
        const categories = document.querySelectorAll(SELECTORS.CATEGORY);
        categories.forEach(category => this.changeActiveCategory(category, gender, category.dataset.gender));

        const subcategoryGroups = document.querySelectorAll(SELECTORS.SUBCATEGORIES);
        subcategoryGroups.forEach(subcategoryGroup => this.changeSubcategoryVisibility(subcategoryGroup, gender, subcategoryGroup.dataset.gender));
    }

    changeActiveCategory(category, gender, currentCategoryGender) {
        const headerColor = DM.Config.headerColor;
        const theme = headerColor === '_black' ? 'dml-page-category__title--black-theme' :
            headerColor === '_white' ? 'dml-page-category__title--white-theme' : '';
        const className = gender == currentCategoryGender ? `dml-page-category__title js-page-nav__category is-active ${theme}` : `dml-page-category__title js-page-nav__category ${theme}`;
        category.classList = className;
    }

    changeSubcategoryVisibility(subcategoryGroup, gender, currentGroupGender) {
        const subcategories = subcategoryGroup.querySelectorAll(SELECTORS.SUBCATEGORY);
        const className = gender == currentGroupGender ? 'dml-page-subcategory js-page-subcategory' : 'dml-page-subcategory dml-page-subcategory--hidden js-page-subcategory';
        subcategories.forEach(subcategory => subcategory.classList = className);
    }

    addShowAll() {
        try {
            const elements = [...document.querySelectorAll(".js-mega-menu-column")].filter(e => e.hasAttribute('data-show-all'));
            for (const index in elements){
                const element = elements[index];
                const key = element.getAttribute('data-show-all');
                const filter = DM.Boot.MegaMenu.filter(m => m.Key === key);
                if (filter.length > 0){
                    const data = filter[0];
                    const li = document.createElement('li');
                    li.classList.add(data.CssClass);
                    const a = document.createElement('a');
                    a.setAttribute('href', data.Url.replaceAll('__', '/'));
                    a.setAttribute('data-tracking-click', data.Tracking);
                    a.setAttribute('data-ga', 'mega_menu.click_subcategory_element');
                    a.setAttribute('data-ga-label', data.Label);
                    a.text = data.Label;
                    li.appendChild(a);
                    element.appendChild(li);
                }
            }
        }catch {
            console.error("Error in mega menu");
        }
    }
}
new Menu();


